import styles from './UserEmailNotifications.module.scss';
import Switch from '../../common/Switch';
import React, { useMemo, useState } from 'react';
import NotificationTableRow from './NotificationTableRow';
import { useDispatch, useSelector } from 'react-redux';
import { updateCurrentUser, updateLoadingNotifications } from '../../../store/actions/users';

export default function NotificationTable(props) {
  const dispatch = useDispatch();
  const { notifications, title = 'Notifications' } = props;
  const { notifications: userNotifications } = useSelector((state) => state.role?.user?.preferences);

  const isEnabled = useMemo(() => {
    if (!userNotifications) return false;
    const activeNotifications = Object.keys(notifications).filter(
      (name) => userNotifications[name]?.enabled && !notifications[name]?.disabled,
    );
    return !!activeNotifications.length;
  }, [notifications, userNotifications]);

  const [isTableEnabled, setIsTableEnabled] = useState(isEnabled);

  const toggleTableNotifications = (value, notifications) => {
    try {
      dispatch(updateLoadingNotifications(true));
      setIsTableEnabled(value);
      const updatedNotifications = {};
      Object.entries(notifications).forEach(([name, notification]) => {
        if (!notification.disabled) {
          updatedNotifications[name] = {
            enabled: value,
            frequency: userNotifications?.[name]?.frequency || notification.value,
          };
        }
      });

      const newNotifications = { ...userNotifications, ...updatedNotifications };

      dispatch(
        updateCurrentUser({
          preferences: {
            notifications: newNotifications,
          },
        }),
      );
    } finally {
      setTimeout(() => dispatch(updateLoadingNotifications()), 1000);
    }
  };

  return (
    <table className={styles.notificationTable}>
      <thead>
        <tr>
          <th className={styles.headerTitle}>{title}</th>
          <th>
            <Switch checked={isTableEnabled} onSwitch={(value) => toggleTableNotifications(value, notifications)} />
          </th>
          <th className={styles.actionTitle}>Schedule</th>
        </tr>
      </thead>
      <tbody>
        {Object.keys(notifications).map((name) => (
          <NotificationTableRow
            key={name}
            defaultNotification={notifications[name]}
            name={name}
            userNotification={userNotifications?.[name]}
            notificationOptions={notifications[name].options}
          />
        ))}
      </tbody>
    </table>
  );
}
